import { combineEpics, ofType, StateObservable } from 'redux-observable';
import { interval, Observable, of } from 'rxjs';
import { catchError, filter, groupBy, map, mergeMap, startWith, throttle } from 'rxjs/operators';
import { requestActions } from './apiHelpers';
import AppState from '../reducers/app-state';
import { ReduxAction } from '@repo/utils/types';
import { apiObservable } from '@repo/utils/helpers/api';
import { selectContactMoments } from '../reducers/data/moments';

/* Epic actions */
const momentsActions = requestActions('MOMENTS', ['fetch']);

/* Epics */
// Request every time contact is being fetched, throttled to <= 60 seconds by contact ID
export const fetchMomentsEpic = (
  action$: Observable<ReduxAction>,
  state$: StateObservable<AppState>,
) =>
  action$.pipe(
    ofType('SELECT_CONTACT'),
    filter(({ payload }) => !!payload?.contact),
    groupBy(({ payload }) => payload.contact.id),
    mergeMap((fetchesByID) =>
      fetchesByID.pipe(
        // If the last fetch failed or we don't have moments loaded yet, fetch immediately. Otherwise,
        // throttle to fetch at most once every minute.
        throttle(({ payload }) => {
          const lastFetch = selectContactMoments(payload.contact.id)(state$.value);
          return lastFetch?.error || !lastFetch.isLoaded ? interval(0) : interval(1000 * 60 * 1);
        }),
        mergeMap(({ payload }) =>
          apiObservable('GET', `/network/contacts/${payload.contact.id}/interactions/summary`).pipe(
            map((response) => {
              return momentsActions['fetchSucceeded']({
                ...response,
                requestID: payload.contact.id,
              });
            }),
            startWith(momentsActions['fetchRequested'](payload.contact)),
            catchError((error) =>
              of(momentsActions['fetchFailed']({ error, contactID: payload.contact.id })),
            ),
          ),
        ),
      ),
    ),
  );

export const momentsEpic = combineEpics(fetchMomentsEpic);
